module.exports = function getResource(label, vars = []) {
    let resources = {
        view12More: 'Afficher 12 autres'
    };
    return resources[label];
};
